// extracted by mini-css-extract-plugin
export var content = "_ar-3";
export var list = "_ar-4";
export var settingsContent = "_ar-7";
export var settingsPanel = "_ar-8";
export var state = "_ar-6";
export var triggerBadge = "_ar-2";
export var triggerButton = "_ar-1";
export var triggerShell = "_ar-0";
export var unreadDot = "_ar-5";